import createUserOperationAPI from './user-apis';
import createMallOperationAPI from './mall-apis';
import createAdOperationAPI from './ad-apis';
import createAxios from './_APITool';

class API {
  static auth = null;

  static mall = null;

  static ad = null;

  static axiosInstance = null;

  static #instance = null;

  static userName = '';

  static get instance() {
    if (!this.#instance) {
      this.#instance = new API();
    }
    if (!this.#instance.axiosInstance) {
      // this.#instance.axiosInstance = createAxios('https://testapi.powerai.com.tw/');
      // this.#instance.axiosInstance = createAxios('http://104.199.181.82:4000/');
      // this.#instance.axiosInstance = createAxios('http://35.220.212.153:4000/');
      this.#instance.axiosInstance = createAxios('https://api.powerai.com.tw/');
      // this.#instance.axiosInstance = createAxios('https://localhost:5102');

      this.#instance.axiosInstance.interceptors.response.use((res) => res, (error) => {
        if (error?.response?.status === 401) {
          // if (error?.errorMsg) {
          //   alert(error.errorMsg);
          //   // alert('登入失敗，請再重新登入，謝謝！');
          // }
          window.location.href = '/';
        }

        return Promise.reject(error);
      });
    }

    const existingAccessToken = localStorage.getItem('access_Token');
    if (existingAccessToken) {
      this.#instance.axiosInstance.defaults.headers.common.Authorization = existingAccessToken;
    }
    if (!this.#instance.auth) {
      this.#instance.auth = createUserOperationAPI(this.#instance.axiosInstance);
    }
    if (!this.#instance.mall) {
      this.#instance.mall = createMallOperationAPI(this.#instance.axiosInstance);
    }
    if (!this.#instance.ad) {
      this.#instance.ad = createAdOperationAPI(this.#instance.axiosInstance);
    }
    return this.#instance;
  }
}

export default API.instance;
